var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "cd-timeline-content mr-3" }, [
      _c("div", [
        _c("div", { staticClass: "cd-timeline-content-text" }, [
          _c("div", { domProps: { innerHTML: _vm._s(_vm.oneLog.text) } }),
          _vm._v(" "),
          _c("div", { staticClass: "grey mt-1 fs-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.$filters.dateFormatter(
                    _vm.oneLog.timestamp,
                    "NORMAL_DATE_TIME",
                    true
                  )
                ) +
                "\n                "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.oneLog.more &&
        Object.values(_vm.oneLog.more).length > 0 &&
        _vm.oneLog.more.logs &&
        Object.values(_vm.oneLog.more.logs).length > 0
          ? _c("div", { staticClass: "cd-timeline-content-detail" }, [
              _c(
                "ul",
                { class: "detail-" + _vm.oneLog.icon },
                _vm._l(_vm.oneLog.more.logs, function(log, index) {
                  return _c("li", { key: index }, [
                    _c("p", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(log.label))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(log.value))
                    ])
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.oneLog.linked.length > 0
          ? _c("div", { staticClass: "cd-timeline-links" }, [
              _c("p", [_vm._v(_vm._s(_vm.$l10n.__("Associé à")))]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.oneLog.linked, function(link, key) {
                  return _c("li", { key: key }, [
                    _c("i", {
                      class: _vm.getIconByType(_vm.oneLog.objecttype)
                    }),
                    _vm._v(" "),
                    _c("span", { domProps: { innerHTML: _vm._s(link.html) } })
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.oneLog.more &&
        Object.values(_vm.oneLog.more).length > 0 &&
        _vm.displayHistory
          ? _c(
              "ul",
              { staticClass: "cd-timeline-content-mail-timeline" },
              _vm._l(_vm.oneLog.more.history, function(log, index) {
                return _c("li", { key: index }, [
                  _c("p", [
                    _c("span", { staticClass: "chip chip-default" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(log.event))]),
                    _vm._v(" "),
                    _c("span", { domProps: { innerHTML: _vm._s(log.more) } }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$filters.dateFormatter(
                            log.timestamp,
                            "NORMAL_DATE_TIME",
                            true
                          )
                        ) +
                        "\n                    "
                    )
                  ])
                ])
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.oneLog.more && _vm.oneLog.more.history
        ? _c(
            "a",
            {
              staticClass: "toggle-historic",
              attrs: {
                "data-toggle": "collapse",
                "data-toggle-text": _vm.$t.__(
                  "timeline.TimelinePrimaryCard.hide_history"
                ),
                href: "#" + _vm.oneLog.uniqid
              }
            },
            [_vm._v(_vm._s(_vm.$l10n.__("Voir l'historique")))]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }